import { addToBag } from '../entry-points/pdp/add-to-bag';

/**
 * Toggles the visibility of an element and updates its aria-hidden attribute.
 * 
 * @param {string} selector - The jQuery selector for the element to toggle.
 * @param {boolean} show - Whether to show or hide the element.
 */
const toggleVisibility = (selector, show) => {
  $(selector).toggle(show).attr('aria-hidden', !show);
};

/**
* Handles the click event for the back button in the qv modal.
* 
* @param {string} sizesContent - The selector for the sizes content element.
*/
const handleBackButtonClick = (sizesContent) => {
  toggleVisibility('.js-shop-the-look-carousel', true);
  toggleVisibility('.js-shop-the-look-sizes', false);
  toggleVisibility(sizesContent, false);
};

/**
* Handles the form submission for adding a product size to the bag.
* 
* @param {Event} e - The form submission event.
* @param {string} productSizes - The name attribute of the product sizes input elements.
* @returns {boolean} - False if the form submission should be prevented.
*/
const handleFormSubmit = (e, productSizes) => {
  if (e) {
    e.preventDefault();
  }
  const $selectedSize = $("input[name='" + productSizes + "']:checked");
  const $errorContainer = $('.js-shop-the-look-error');
  const sizeVal = $selectedSize.val();

  if (!sizeVal) {
      $errorContainer.show().trigger('focus');
      $(`input[name='${productSizes}']`).on('click', () => {
          $errorContainer.hide();
      });
      return false;
  }

  addToBag($selectedSize.data('code'), sizeVal);
};

/**
* Handles the click event for the add-to-bag button, showing the appropriate sizes content.
* 
* @param {jQuery} addToBagProduct - The jQuery object for the add-to-bag button.
*/
const handleAddToBagClick = (addToBagProduct) => {
  const sizesContent = `#${addToBagProduct.data('sizeContent')}`;
  const productSizes = addToBagProduct.data('sizes');

  if ($("input[name='" + productSizes + "']:checked").length) {
    handleFormSubmit(null, productSizes);
  } else {
    toggleVisibility('.js-shop-the-look-carousel', false);
    toggleVisibility('.js-shop-the-look-sizes', true);
    toggleVisibility(sizesContent, true);

    $('.js-shop-the-look-back').on('click', () => handleBackButtonClick(sizesContent));
    $('#shop-the-look-size-atb').on('submit', (e) => handleFormSubmit(e, productSizes));
  }
};

/**
* Initializes and opens the qv modal, setting up event handlers.
*/
const openModal = (triggerElement) => {
    const paramsData = {
        qvId: triggerElement.data("qvId"),
    };
    const navSrc = triggerElement.data("navsrc");
    if (navSrc && navSrc.length > 0) {
        paramsData['navsrc'] = navSrc;
    }

    if (window.rcProps.isApp) {
      window.location.href =
        `${window.rcProps.shopTheLookModalHref}?qvId=${paramsData.qvId}&navSrc=${paramsData.navsrc}`;
    } else {
      $.modal({
        data: paramsData,
        url: window.rcProps.shopTheLookModalHref,
        triggerOpen: true,
        addModifierClass: 'modal--toast-no-padding-x',
        type: 'toast',
        triggerElement,
        hasBodyScroll: false,
        onComplete: () => {
          $('.js-horizontal-scroll').horizontalScroll();
          $('.js-qv-multi-add').on('click', (evt) => {
            const addToBagProduct = $(evt.currentTarget);
            handleAddToBagClick(addToBagProduct);
          });
        },
      });
    }
};

/**
* Sets up the click event listener to open the qv modal.
* 
* @param {jQuery} $el - The jQuery object for the modal trigger element.
*/
const setEventListeners = ($el) => {
  $el.on('click', (e) => {
      const triggerElement = $(e.currentTarget);
      console.log('triggerElement', triggerElement);
      openModal(triggerElement);
  });
};

/**
* Initializes the Quick View Multi-Products modal and sets up event listeners.
*/
export default function shopTheLook() {
  const $el = $('.js-shop-the-look');
  if ($el.length) {
    setEventListeners($el);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/shop-the-look.js